import icon from 'vue-svgicon';

icon.register({
    'bold/arrow-thick-circle-bottom-left-corner': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M20.485 3.515a12 12 0 1 0 0 16.97 12.013 12.013 0 0 0 0-16.97zm-2.3 5.477l-4.419 4.419a.25.25 0 0 0 0 .354l2.679 2.679a.5.5 0 0 1-.353.854H7.2a.5.5 0 0 1-.5-.5v-8.89a.5.5 0 0 1 .853-.354l2.678 2.678a.25.25 0 0 0 .354 0l4.422-4.417a.5.5 0 0 1 .707 0l2.469 2.47a.5.5 0 0 1 .001.707z"/>`,
    },
});
